<template>
  <b-card>
    <b-overlay
      :show="loading"
      variant="white"
      spinner-variant="primary"
      rounded="lg"
      :opacity=".7"
    >
      <ValidationObserver ref="form">
        <Form
          :clinic-data.sync="formData"
          :cities-list="citiesList"
          :clinic-networks-list="clinicNetworksList"
          :clinic-types-list="clinicTypes"
          @formSubmitClose="doFormSave"
        />
      </ValidationObserver>
    </b-overlay>
  </b-card>
</template>

<script>
import { BCard, BOverlay } from 'bootstrap-vue'
import _ from 'lodash'
import axiosIns from '@/libs/axios'
import store from '@/store'
import { FormDataConverter } from '@/mixins/formData'
import Form from './Form.vue'

const emptyFormData = {
  id: null,
  slug: '',
  name: '',
  city_id: null,
  network_id: null,
  address: '',
  phone: '',
  latitude: '',
  longitude: '',
  transit_help: '',
  web_site_url: '',
  ad_site_url: '',
  description: '',
  schedule: '',
  official_name: '',
  director: '',
  opening_year: '',
  payment_method: '',
  client_types: '',
  rating_personal: 0,
  rating_equipment: 0,
  id_docdoc: '',
  type_id: null,
}

export default {
  name: 'ClinicsCreate',
  components: {
    BCard,
    BOverlay,
    Form,
  },
  metaInfo: {
    title: 'Создание клиники',
  },
  data() {
    return {
      formData: _.cloneDeep(emptyFormData),
      loading: true,
      serverErrors: {},
      citiesList: [],
      clinicNetworksList: [],
      clinicTypes: [],
    }
  },
  mounted() {
    Promise.all([
      this.doLoadCities(),
      this.doLoadClinicNetworks(),
      this.doLoadClinicTypes(),
    ]).then(() => {
      this.loading = false
    })
  },
  beforeDestroy() {
    store.commit('app/UPDATE_CURRENT_PAGE_TITLE', null)
  },
  methods: {
    async doFormSave() {
      this.loading = true

      const formData = new FormDataConverter(this.formData)

      try {
        const res = await axiosIns({
          method: 'POST',
          url: 'clinics/create',
          data: formData.getData(),
        })
        this.loading = false
        if (res.data.status === 'success') {
          await this.$router.push({ name: 'clinics' })
          this.sendToast({
            title: 'Успех!',
            icon: 'CheckCircleIcon',
            text: 'Клиника создана, теперь она доступна для редактирования',
            variant: 'success',
          })
        }
      } catch (error) {
        this.loading = false
        if (error.response.status === 422) {
          this.serverErrors = error.response.data.data
          this.$refs.form.setErrors(this.serverErrors)
          this.sendToast({
            title: 'Ошибка!',
            icon: 'AlertCircleIcon',
            text: 'Не все поля заполнены!',
            variant: 'danger',
          })
        }
      }
    },
    async doLoadCities() {
      const response = await axiosIns({
        method: 'GET',
        url: '/cities/options',
      })

      this.citiesList = response.data.data

      return response
    },
    async doLoadClinicNetworks() {
      const res = await axiosIns({
        method: 'GET',
        url: '/clinic_networks/options',
      })

      this.clinicNetworksList = res.data.data

      return res
    },
    async doLoadClinicTypes() {
      const res = await axiosIns({
        method: 'GET',
        url: '/clinic_types/options',
      })

      this.clinicTypes = res.data.data

      return res
    },
  },
}
</script>
